<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="150px"
      class="form form-medium"
    >

      <el-form-item label="所属积分活动">
        <v-select-integral-activity
          v-model="post.integral_activity_id"
          placeholder="输入活动标题进行搜索"
        />
      </el-form-item>

      <v-image-upload
        v-model="post.entity_cover"
        label="实物奖励图片"
        prefix="integral-activity"
        ratio="1:1"
        propName="entity_cover"
      />

      <el-form-item label="实物奖励名称">
        <el-input
          v-model="post.entity_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入实物奖励名称"
        />
      </el-form-item>

      <el-form-item label="实物奖励数量">
        <v-input-number
          v-model="post.entity_count"
          :is-show-suffix="true"
          suffix-name="个"
          placeholder="请输入实物奖励数量"
        />
      </el-form-item>

      <el-form-item label="目标节数" prop="signed_count">
        <v-input-money
          placeholder="请输入活动期间累计签到的课程节数"
          v-model="post.signed_count"
          :is-show-suffix="true"
          suffix-name="节"
          :min="1"
          :max="500"
        />
      </el-form-item>

      <el-form-item label="积分奖励" prop="integral">
        <v-input-money
          placeholder="请输入活动期间完成目标次数后所得积分"
          v-model="post.integral"
          :is-show-suffix="true"
          suffix-name="分"
          :min="1"
          :max="1000"
        />
      </el-form-item>

      <el-form-item label="开始时间" prop="start_time">
        <el-date-picker
          v-model="post.start_time"
          :picker-options="pickerOptionsOfAfterSystemStartDay"
          type="datetime"
          placeholder="请选择活动开始时间"
          value-format="timestamp"
        />
      </el-form-item>

      <el-form-item label="结束时间" prop="end_time">
        <el-date-picker
          v-model="post.end_time"
          :picker-options="endTimeOptions"
          type="datetime"
          placeholder="请选择活动结束时间"
          value-format="timestamp"
        />
      </el-form-item>

      <el-form-item label="目标简介" prop="brief_target">{{ post.brief_target }}</el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.integralActivityList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { formatTimestamp, pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
import { show, update } from '@/api/integral-activity-target';
import { toCent, toMillisecond, toSecond, toYuan } from '@/filters';

export default {
  name: RouteConfig.integralActivityTargetEdit.name,
  data: () => ({
    RouteConfig,
    pickerOptionsOfAfterSystemStartDay,
    isSaving: false,
    post: {
      update_time: 0,
      integral_activity_id: 0,
      activity_type: 0,
      title: '',
      brief: '',
      banner: '',
      cover: '',
      entity_cover: '',
      entity_name: '',
      entity_count: 0,
      rule: '',
      integral: '',
      signed_count: '',
      start_time: '',
      end_time: '',
      brief_target: '',
    },
    endTimeOptions: {
      disabledDate: null,
    },
    rules: {
      signed_count: [{ required: true, message: '请输入 1 ~ 500 范围内的累计签到次数', trigger: 'change' }],
      integral: [{ required: true, message: '请输入 1 ~ 1000 范围内的积分', trigger: 'change' }],
      start_time: [{ required: true, message: '请输入活动开始时间', trigger: 'change' }],
      end_time: [{ required: true, message: '请输入活动结束时间', trigger: 'change' }],
    },
  }),
  watch: {
    'post.start_time'(time) {
      if (this.post.end_time <= time) this.post.end_time = '';
      this.setBriefTarget();
    },
    'post.end_time'() {
      this.setBriefTarget();
    },
    'post.signed_count'() {
      this.setBriefTarget();
    },
  },
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  created() {
    this.endTimeOptions.disabledDate = (time) => {
      return time.getTime() <= this.post.start_time;
    };
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { post } = this;
      const newPost = {};
      Object.keys(data).forEach(key => {
        if (key in post) newPost[key] = data[key];
      });
      if (newPost.start_time) newPost.start_time = toMillisecond(newPost.start_time);
      if (newPost.end_time) newPost.end_time = toMillisecond(newPost.end_time);
      if (newPost.integral) newPost.integral = toYuan(newPost.integral);
      if (newPost.signed_count) newPost.signed_count = toYuan(newPost.signed_count);

      Object.assign(post, newPost);
    },
    setBriefTarget() {
      if (!this.post.start_time || !this.post.end_time || !this.post.signed_count) return this.post.brief_target = '';

      const startTime = formatTimestamp(this.post.start_time);
      const endTime =  formatTimestamp(this.post.end_time);
      this.post.brief_target = `${startTime} ~ ${endTime}内签到对应课程 ≥ ${this.post.signed_count} 节`;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const post = { ...this.post };
        post.start_time = toSecond(post.start_time);
        post.end_time = toSecond(post.end_time);
        post.integral = toCent(post.integral);
        post.signed_count = toCent(post.signed_count);
        const { isError } = await update(this.id, post);
        this.isSaving = false;
        if (!isError) RouteConfig.integralActivityTargetList.push();
      });
    },
  },
};
</script>
